import { useTranslation } from 'react-i18next';
import { TagOrigin, TagStatus, TagValidationStatus } from 'entities/tag';

import './TagBadges.scss';

export const StatusBadge = ({ status }: { status?: TagStatus }) => {
  const { t } = useTranslation('tag');

  return status ? <span className={`tag-badge tag-badge--status-${status}`}>{t(`status.${status}`)}</span> : <>-</>;
};

export const ValidationBadge = ({ status }: { status?: TagValidationStatus }) => {
  const { t } = useTranslation('tag');

  return status ? <span className={`tag-badge tag-badge--status-${status}`}>{t(`status.${status}`)}</span> : <>-</>;
};

export const OriginBadge = ({ origin }: { origin?: TagOrigin }) => {
  const { t } = useTranslation('tag');

  return <span className={`tag-badge tag-badge--origin-${origin ?? 'human'}`}>{t(`ai.origin.${origin ?? 'human'}`)}</span>;
};
